import { Outlet } from '@tanstack/react-router';
import { SearchProvider } from '@/context';
export const Layout = () => {
  return (
    <SearchProvider>
      <main className="">
        <Outlet />
      </main>
    </SearchProvider>
  );
};
